import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })
export class AuthFlowService {
  // private readonly authUrl = 'http://192.168.176.99:3000/api/v1/auth';
    private readonly authUrl = environment.authUrl;
    private readonly usersUrl = environment.usersUrl;
    private readonly testUrl = environment.testUrl;

  constructor(private http: HttpClient) { }

  // SIGNUP  API
  checkMobileAndSendOtp(mobileNumber: string) {
    return this.http.post(`${this.authUrl}/send-otp`, { mobileNumber });
  }
  verifyOtp(mobileNumber: string, otp: string) {
    return this.http.post(`${this.authUrl}/verify-otp`, { mobileNumber, otp });
  }
  signUp(payload: any) {
    return this.http.post(`${this.authUrl}/signup`, payload);
  }
   signUpSendOtp(mobileNumber: string) {
    return this.http.post(`${this.authUrl}/resend-otp`, { mobileNumber });
  }


// SIGNIN API
  login(payload: any) {
    return this.http.post(`${this.authUrl}/login`, payload);
  }
  loginWithOtp(payload: any) {
    return this.http.post(`${this.authUrl}/login/otp/verify`, payload);
  }
  sendOtp(payload: any) {
    return this.http.post(`${this.authUrl}/login/otp/request`, payload);
  }
  loginResendOtp(mobileNumber: string) {
    return this.http.post(`${this.authUrl}/login/otp/resend`, { mobileNumber });
  }

  // LOGOUT API
  logout() {
    return this.http.post(`${this.authUrl}/logout`, {});
  }



//  FORGET PASSWORD API
  forgetsendOtp(mobileNumber: string) {
    return this.http.post(`${this.authUrl}/reset-password/otp/send`, { mobileNumber });
  }
  resendOtp(mobileNumber: any) {
    return this.http.post(`${this.authUrl}/reset-password/otp/resend`, {mobileNumber});
  }
  verifyResetOtp(payload: {mobileNumber: string; otp: string;}) {
    return this.http.post(`${this.authUrl}/reset-password/otp/verify`, payload);
  }

  resetPassword(payload: any) {
    return this.http.post(`${this.authUrl}/reset-password/create`, payload);
  }
  submitNeedHelp(payload: any) {
    return this.http.post(`${this.testUrl}/submitHelpRequest`, payload);
  }

  //profile
  updateProfile(payload: any) {
    return this.http.put(`${this.usersUrl}/profile`, payload);
  }



}
